module.exports = __webpack_public_path__ + "static/gtm_5-055663b366651c3d90b29b55398e23c0.png";